import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const InterrogationIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 44 44" {...props}>
    <g id="picto" transform="translate(-671.131 -902.142)">
      <circle
        id="fond"
        cx="22"
        cy="22"
        r="22"
        transform="translate(671.131 902.142)"
        fill="#debf82"
      />
      <g
        id="Groupe_5592"
        data-name="Groupe 5592"
        transform="translate(686.131 912.142)"
      >
        <path
          id="Tracé_395"
          data-name="Tracé 395"
          d="M321,186.822a6.411,6.411,0,0,0-7.543,6.314,1.6,1.6,0,0,0,3.205,0,3.208,3.208,0,0,1,3.209-3.205,3.172,3.172,0,0,1,.587.055,3.24,3.24,0,0,1,2.561,2.561,3.2,3.2,0,0,1-1.925,3.544,4.668,4.668,0,0,0-2.829,4.367v.673a1.6,1.6,0,0,0,3.205,0v-.673a1.513,1.513,0,0,1,.843-1.414A6.412,6.412,0,0,0,321,186.822Z"
          transform="translate(-312.983 -186.25)"
          fill="#fff"
        />
        <path
          id="Tracé_406"
          data-name="Tracé 406"
          d="M326.4,190.681a6.855,6.855,0,0,0-10.259-2.979,6.767,6.767,0,0,0-2.829,4.431,6.607,6.607,0,0,0-.113,1.208,2.075,2.075,0,0,0,4.15,0,2.736,2.736,0,0,1,2.734-2.734,3.634,3.634,0,0,1,.489.057,2.728,2.728,0,0,1,.547,5.2,5.125,5.125,0,0,0-3.11,4.809v.66a2.074,2.074,0,1,0,4.148,0v-.679a1.019,1.019,0,0,1,.547-.961A6.893,6.893,0,0,0,326.4,190.681Zm-5.186,10.655a1.132,1.132,0,0,1-2.264,0v-.679a4.183,4.183,0,0,1,2.528-3.924,3.662,3.662,0,0,0-.717-7,4.293,4.293,0,0,0-.679-.075,3.682,3.682,0,0,0-3.678,3.678,1.132,1.132,0,0,1-2.264,0,6.438,6.438,0,0,1,.095-1.038,5.925,5.925,0,1,1,8.09,6.525,1.962,1.962,0,0,0-1.113,1.848Z"
          transform="translate(-313.196 -186.463)"
          fill="#debf82"
        />
      </g>
      <g
        id="Groupe_5593"
        data-name="Groupe 5593"
        transform="translate(690.299 931.145)"
      >
        <ellipse
          id="Ellipse_45"
          data-name="Ellipse 45"
          cx="1.886"
          cy="1.886"
          rx="1.886"
          ry="1.886"
          transform="translate(0.468 0.474)"
          fill="#fff"
        />
        <path
          id="Tracé_407"
          data-name="Tracé 407"
          d="M317.838,196.88a2.357,2.357,0,1,0,2.357,2.357A2.358,2.358,0,0,0,317.838,196.88Zm0,3.771a1.414,1.414,0,1,1,0-2.828,1.414,1.414,0,1,1,0,2.828Z"
          transform="translate(-315.481 -196.88)"
          fill="#debf82"
        />
      </g>
    </g>
  </SvgIcon>
));

export default React.memo(InterrogationIcon);
